<template>
	<div class="article-detail-container">
		<Hrader :idShwo="7"></Hrader>
		<div style="height: 70px"></div>
		<div>
			<img src="../../assets/news/Maskgroup.png" style="width: 100%; height: auto" />
		</div>

		<div class="rectangle" style="margin-top: -10px">
			<div class="rectangle-with">
				<div class="flex-rectange">
					<div>
						<img src="../../assets/recycling_slices/Vector@2x.png" style="width: 12px; height: 13px" />
					</div>
					<div class="current-recy">当前位置 : 卡券新闻 | <span class="category-name">{{ currentCategoryName }}</span></div>
				</div>
			</div>
		</div>

		<div class="main-content">
			<div class="sidebar">
				<div 
					v-for="(item, index) in categories" 
					:key="index" 
					class="sidebar-item"
					:class="{ 'sidebar-item-active': currentIndex === index }"
					@click="selectCategory(index)"
				>
					<img :src="currentIndex === index ? item.activeIcon : item.icon" class="sidebar-icon" />
					<span>{{ item.name }}</span>
				</div>
			</div>

			<div class="content-area">
				<div class="article-header">
					<h1 class="article-title">{{ article.title }}</h1>
					<div class="article-meta">
						<span class="article-date">{{ article.date }}</span>
						<span class="article-views">
							<img src="@/assets/news/Vector.png" class="view-icon" />
							{{ article.views }}
						</span>
						<div class="share-module">
							<img src="@/assets/news/fx.png" class="share-icon" />
							<span class="share-text">分享到</span>
							<div class="share-icons">
								<img src="@/assets/news/wx.png" class="share-item" @click="showWxQrCode" />
								<img src="@/assets/news/wb.png" class="share-item" @click="shareTo('weibo')" />
								<img src="@/assets/news/tb.png" class="share-item" @click="shareTo('tieba')" />
								<img src="@/assets/news/db.png" class="share-item" @click="shareTo('douban')" />
								<img src="@/assets/news/qq.png" class="share-item" @click="shareTo('qq')" />
								<img src="@/assets/news/kj.png" class="share-item" @click="shareTo('qqspace')" />
							</div>
						</div>
					</div>
					<button class="recycle-btn" @click="goToRecycle">立即回收</button>
				</div>

				<div class="article-content" v-html="article.content"></div>

				<div class="article-nav">
					<div class="nav-item">
						<span class="nav-label">上一篇：</span>
						<a 
							v-if="prevArticle" 
							:href="`/articleDetail?articleId=${prevArticle.id}&categoryId=${article.category}`" 
							class="nav-link"
						>{{ prevArticle.title }}</a>
						<span v-else class="nav-link disabled">暂无</span>
					</div>
					<div class="nav-item">
						<span class="nav-label">下一篇：</span>
						<a 
							v-if="nextArticle" 
							:href="`/articleDetail?articleId=${nextArticle.id}&categoryId=${article.category}`" 
							class="nav-link"
						>{{ nextArticle.title }}</a>
						<span v-else class="nav-link disabled">暂无</span>
					</div>
				</div>

				<div class="related-news">
					<h3 class="related-title">相关新闻</h3>
					<div v-if="relatedNews.length === 0" class="empty-state">
						<span class="empty-text">暂无相关新闻</span>
					</div>
					<div v-else class="related-list">
						<div 
							v-for="(news, index) in relatedNews" 
							:key="index" 
							class="related-item"
							@click="goToArticle(news)"
						>
							<h4 class="related-news-title">{{ news.title }}</h4>
							<p class="related-desc">{{ news.desc }}</p>
							<div class="related-meta">
								<span class="related-date">{{ news.date }}</span>
								<span class="related-views">
									<img src="@/assets/news/Vector.png" class="related-view-icon" />
									{{ news.views }}
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="tags-section">
			<div class="tags-container">
				<div 
					v-for="(tag, index) in tags" 
					:key="index" 
					class="tag-item"
					:style="{ backgroundColor: tag.bgColor, color: tag.textColor }"
				>
					{{ tag.name }}
				</div>
			</div>
		</div>

		<Tabr></Tabr>
		<Customer></Customer>
	</div>

	<div v-if="showQrCodeModal" class="qr-code-modal" @click="closeQrCodeModal">
		<div class="qr-code-content" @click.stop>
			<div class="qr-code-header">
				<span class="qr-code-title">微信扫码分享</span>
				<button class="qr-code-close" @click="closeQrCodeModal">×</button>
			</div>
			<div class="qr-code-body">
				<div class="qr-code-wrapper">
					<qrcode-vue :value="qrCodeUrl" :size="180" level="H" />
				</div>
				<p class="qr-code-tip">使用微信扫一扫</p>
				<p class="qr-code-desc">扫码后可在手机端阅读此文章</p>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Hrader from '@/components/header.vue';
import Tabr from '@/components/tabrButton.vue';
import Customer from '@/components/customer.vue';
import { cardNewsTagList, cardNewsArticleGet, cardNewsTypeList, cardNewsArticlePage, cardNewsArticleTopBrowse } from '@/utils/api.js';
import QrcodeVue from 'qrcode.vue';

const route = useRoute();
const router = useRouter();

const currentIndex = ref(0);

const categories = ref([
	{ id: 0, name: '最新新闻', icon: require('@/assets/news/list1.png'), activeIcon: require('@/assets/news/sel1.png') }
]);

const tags = ref([]);

const articleData = ref({
	title: '',
	date: '',
	views: '',
	content: '',
	category: 0,
	id: 0
});

const article = computed(() => articleData.value);

const prevArticle = ref(null);
const nextArticle = ref(null);

const showQrCodeModal = ref(false);
const qrCodeUrl = ref('');

const currentCategoryName = computed(() => {
	return categories.value[currentIndex.value]?.name || '最新新闻';
});

const relatedNews = ref([]);

const fetchRelatedNews = async () => {
	try {
		const typeId = articleData.value.category || 0;
		const excludeArticleId = articleData.value.id;
		const res = await cardNewsArticleTopBrowse({ typeId, size: 6, excludeArticleId });
		if (res.code === 0 && res.data) {
			relatedNews.value = res.data.map(item => ({
				id: item.id,
				title: item.title,
				desc: item.summary,
				date: formatDate(item.publishTime || item.createTime),
				views: item.browseCount || item.viewCount || 0
			}));
		}
	} catch (error) {
		console.error('获取热门浏览新闻失败:', error);
	}
};

const selectCategory = (index) => {
	const category = categories.value[index];
	if (category) {
		router.push({
			path: '/newsDetail',
			query: {
				categoryId: category.id
			}
		});
	}
};

const goToRecycle = () => {
	router.push('/cardVoucher');
};

const goToArticle = (news) => {
	if (!news || !news.id) {
		console.error('新闻数据无效');
		return;
	}
	console.log('点击新闻:', news.id, news.title);
	
	const currentId = route.query.articleId;
	if (currentId === String(news.id)) {
		console.log('已在当前文章页面');
		return;
	}
	
	router.replace({
		path: '/articleDetail',
		query: {
			articleId: news.id,
			timestamp: Date.now()
		}
	}).then(() => {
		console.log('跳转成功，重新加载文章数据');
		fetchArticleDetail();
		fetchRelatedNews();
	}).catch(err => {
		console.error('跳转失败:', err);
	});
};

const showWxQrCode = () => {
	const articleId = route.query.articleId || articleData.value.id;
	const categoryId = route.query.categoryId || articleData.value.category;
	
	if (!articleId) {
		console.error('无法获取文章ID');
		return;
	}
	
	const url = `https://mobile.baiyuehuishou.com/pages/articleDetail/index?id=${articleId}${categoryId ? `&typeId=${categoryId}` : ''}`;
	
	qrCodeUrl.value = url;
	showQrCodeModal.value = true;
	console.log('生成的二维码URL:', qrCodeUrl.value);
};

const closeQrCodeModal = () => {
	showQrCodeModal.value = false;
};

const getShareUrl = () => {
	const articleId = articleData.value.id;
	const categoryId = articleData.value.category;
	if (!articleId) {
		return window.location.href;
	}
	return `https://mobile.baiyuehuishou.com/pages/articleDetail/index?id=${articleId}${categoryId ? `&typeId=${categoryId}` : ''}`;
};

const openUrlNoReferrer = (url) => {
	const a = document.createElement('a');
	a.href = url;
	a.target = '_blank';
	a.rel = 'noopener noreferrer';
	a.style.display = 'none';
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
};

const shareTo = (type) => {
	const url = getShareUrl();
	const title = articleData.value.title || '卡券新闻';
	let shareUrl = '';
	let useNoReferrer = false;

	switch (type) {
		case 'weibo':
			shareUrl = `https://service.weibo.com/share/share.php?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`;
			break;
		case 'tieba':
			shareUrl = `https://tieba.baidu.com/f/commit/share/openShareApi?title=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`;
			break;
		case 'qqzone':
			shareUrl = `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}&desc=${encodeURIComponent(title)}`;
			break;
		case 'qqspace':
			shareUrl = `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}&desc=${encodeURIComponent(title)}`;
			break;
		case 'douban': {
				const shareServiceUrl = `https://www.douban.com/share/service?href=${encodeURIComponent(url)}&name=${encodeURIComponent(title)}&image=`;
				shareUrl = `https://accounts.douban.com/passport/login?redir=${encodeURIComponent(shareServiceUrl)}`;
				useNoReferrer = true;
				break;
			}
		case 'qq':
			shareUrl = `https://connect.qq.com/widget/shareqq/index.html?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}&desc=${encodeURIComponent(title)}`;
			break;
		default:
			return;
	}

	if (shareUrl) {
		if (useNoReferrer) {
			openUrlNoReferrer(shareUrl);
		} else {
			window.open(shareUrl, '_blank');
		}
	}
};

const copyLink = async () => {
	const url = window.location.href;
	try {
		await navigator.clipboard.writeText(url);
		ElMessage.success('链接已复制到剪贴板');
	} catch (err) {
		const textarea = document.createElement('textarea');
		textarea.value = url;
		document.body.appendChild(textarea);
		textarea.select();
		document.execCommand('copy');
		document.body.removeChild(textarea);
		ElMessage.success('链接已复制到剪贴板');
	}
};

const fetchNewsTags = async () => {
	try {
		const res = await cardNewsTagList();
		if (res.code === 0 && res.data) {
			tags.value = res.data.map(item => ({
				name: item.name,
				bgColor: item.bgColor,
				textColor: item.textColor
			}));
		}
	} catch (error) {
		console.error('获取新闻标签列表失败:', error);
	}
};

const getIcon = (item) => {
	if (item.navIcon && item.navIcon !== '0') {
		return item.navIcon;
	}
	return item.logo;
};

const fetchNewsTypes = async () => {
	try {
		const res = await cardNewsTypeList();
		if (res.code === 0 && res.data) {
			const typeList = res.data.map(item => ({
				id: item.id,
				name: item.mainTitle,
				icon: getIcon(item),
				activeIcon: getIcon(item)
			}));
			categories.value = [{ id: 0, name: '最新新闻', icon: require('@/assets/news/list1.png'), activeIcon: require('@/assets/news/sel1.png') }, ...typeList];
		}
	} catch (error) {
		console.error('获取新闻类型列表失败:', error);
	}
};

const formatDate = (timestamp) => {
	if (!timestamp) return '';
	const date = new Date(timestamp);
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	return `${year}年${month}月${day}日`;
};

const fetchArticleDetail = async () => {
	const articleId = route.query.articleId;
	if (!articleId) return;

	try {
		const res = await cardNewsArticleGet({ id: articleId });
		if (res.code === 0 && res.data) {
			const data = res.data;
			articleData.value = {
				title: data.title || '',
				date: formatDate(data.publishTime || data.createTime),
				views: data.browseCount || data.viewCount || 0,
				category: data.typeId || 0,
				content: data.content || '',
				id: data.id || 0
			};

			if (data.typeId !== undefined) {
				const idx = categories.value.findIndex(c => c.id === data.typeId);
				if (idx >= 0) {
					currentIndex.value = idx;
				}
			}

			await fetchPrevNextArticles(data.id, data.typeId);
		}
	} catch (error) {
		console.error('获取文章详情失败:', error);
	}
};

const fetchPrevNextArticles = async (currentId, typeId) => {
	try {
		const params = {
			page: 1,
			size: 20
		};
		if (typeId && typeId !== 0) {
			params.typeId = typeId;
		}

		const res = await cardNewsArticlePage(params);
		if (res.code === 0 && res.data && res.data.list) {
			const articles = res.data.list;
			const currentIndex = articles.findIndex(item => item.id === currentId);

			if (currentIndex >= 0) {
				if (currentIndex > 0) {
					prevArticle.value = {
						id: articles[currentIndex - 1].id,
						title: articles[currentIndex - 1].title
					};
				} else {
					prevArticle.value = null;
				}

				if (currentIndex < articles.length - 1) {
					nextArticle.value = {
						id: articles[currentIndex + 1].id,
						title: articles[currentIndex + 1].title
					};
				} else {
					nextArticle.value = null;
				}
			}
		}
	} catch (error) {
		console.error('获取上下篇文章失败:', error);
	}
};

onMounted(() => {
	fetchNewsTypes().then(() => {
		const categoryId = route.query.categoryId;
		if (categoryId !== undefined) {
			const id = parseInt(categoryId);
			if (!isNaN(id) && id >= 0) {
				const idx = categories.value.findIndex(c => c.id === id);
				if (idx >= 0) {
					currentIndex.value = idx;
				}
			}
		}
		fetchArticleDetail().then(() => {
			fetchRelatedNews();
		});
	});
	fetchNewsTags();
});

watch(() => route.query.articleId, (newId, oldId) => {
	if (newId && newId !== oldId) {
		console.log('文章ID变化:', oldId, '->', newId);
		fetchArticleDetail().then(() => {
			fetchRelatedNews();
		});
	}
});
</script>

<style lang="scss" scoped>
.article-detail-container {
	min-height: 100vh;
	background-color: #f5f5f5;
}

.rectangle {
	width: 100%;
	height: 52px;
	background: #ffffff;
	border-radius: 0px;
}

.rectangle-with {
	width: 1280px;
	margin: auto;
	height: 52px;
}

.flex-rectange {
	display: flex;
	align-items: center;
	height: 52px;
	margin-left: 22px;
}

.current-recy {
	margin-left: 7px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
}

.category-name {
	color: #FF3333;
}

.main-content {
	max-width: 1280px;
	margin: 20px auto;
	display: flex;
	gap: 20px;
}

.sidebar {
	width: 160px;
	height: 100%;
	background: #ffffff;
	border-radius: 8px;
	padding: 18px 18px 18px 0;
	flex-shrink: 0;
}

.sidebar-item {
	display: flex;
	align-items: center;
	padding: 12px 0 12px 8px;
	// margin-left: 18px;
	margin-bottom: 5px;
	border-radius: 0 8px 8px 0;
	cursor: pointer;
	transition: all 0.3s;
	color: #666666;
	font-size: 16px;
}

.sidebar-item-active {
	background: linear-gradient(90deg, #FF3333 57.85%, rgba(255,51,51,0.8) 100%);
	color: #ffffff;
	border-radius: 0 8px 8px 0;
	margin-left: 0;
	// padding-left: 33px;
}

.sidebar-icon {
	width: 16px;
	height: 16px;
	margin-right: 10px;
}

.content-area {
	flex: 1;
	background: #ffffff;
	border-radius: 8px;
	padding: 30px;
	min-height: 600px;
}

.article-header {
	margin-bottom: 30px;
	position: relative;
}

.article-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 24px;
	color: #333333;
	margin: 0 0 20px 0;
	line-height: 1.4;
}

.article-meta {
	display: flex;
	align-items: center;
	gap: 20px;
	padding-bottom: 20px;
	border-bottom: 1px solid #EEEEEE;
}

.article-date {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #B3B3B3;
}

.article-views {
	display: flex;
	align-items: center;
	gap: 5px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #B3B3B3;
}

.view-icon {
	width: 14px;
	height: 14px;
	object-fit: contain;
}

.share-module {
	display: flex;
	align-items: center;
	gap: 8px;
}

.share-icon {
	width: 14px;
	height: 14px;
	object-fit: contain;
}

.share-text {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #B3B3B3;
}

.share-icons {
	display: flex;
	align-items: center;
	gap: 12px;
}

.share-item {
	width: 20px;
	height: 20px;
	object-fit: contain;
	cursor: pointer;
	transition: opacity 0.3s;
}

.share-item:hover {
	opacity: 0.7;
}

.article-content {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	line-height: 1.8;
}

.article-content h2 {
	font-size: 18px;
	font-weight: 600;
	color: #333333;
	margin: 25px 0 15px 0;
}

.article-content h3 {
	font-size: 16px;
	font-weight: 500;
	color: #333333;
	margin: 20px 0 10px 0;
}

.article-content p {
	margin: 15px 0;
	text-indent: 2em;
}

.recycle-btn {
	position: absolute;
	top: 0;
	right: 0;
	width: 194px;
	height: 53px;
	background: linear-gradient( 270deg, #FF3333 0%, #FF7433 100%);
	border-radius: 4px 4px 4px 4px;
	border: 1px solid #FF2F17;
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 18px;
	color: #ffffff;
	cursor: pointer;
	transition: all 0.3s;
}

.recycle-btn:hover {
	background: linear-gradient(270deg, #E62E2E 0%, #FF6B6B 100%);
}

.article-nav {
	margin: 30px 0;
	padding: 15px 0;
	border-bottom: 1px solid #EEEEEE;
}

.nav-item {
	display: flex;
	align-items: center;
	margin-bottom: 10px;
}

.nav-item:last-child {
	margin-bottom: 0;
}

.nav-label {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #666666;
}

.nav-link {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #FF3333;
	text-decoration: none;
	margin-left: 5px;
	cursor: pointer;
}

.nav-link:hover {
	text-decoration: underline;
}

.nav-link.disabled {
	color: #CCCCCC;
	cursor: not-allowed;
}

.related-news {
	margin-top: 20px;
}

.related-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 18px;
	color: #333333;
	margin: 0 0 20px 0;
}

.empty-state {
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 150px;
	background: #FFFFFF;
	border: 1px solid #E4E4E4;
	border-radius: 8px;
}

.empty-text {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #999999;
}

.related-list {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 22px;
}

.related-item {
	display: flex;
	flex-direction: column;
	padding: 22px 16px;
	background: #FFFFFF;
	border: 1px solid #E4E4E4;
	border-radius: 8px;
	cursor: pointer;
	transition: all 0.3s;
}

.related-item:hover {
	border-color: #FF3333;
	box-shadow: 0 2px 8px rgba(255, 51, 51, 0.1);
}

.related-news-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 16px;
	color: #333333;
	margin: 0 0 10px 0;
	line-height: 1.5;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
}

.related-desc {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #999999;
	margin: 0 0 8px 0;
	line-height: 1.5;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	flex: 1;
	max-height: 40px;
}

.related-meta {
	display: flex;
	align-items: center;
	gap: 15px;
}

.related-date {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 12px;
	color: #B3B3B3;
}

.related-views {
	display: flex;
	align-items: center;
	gap: 4px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 12px;
	color: #B3B3B3;
}

.related-view-icon {
	width: 14px;
	height: 11px;
	object-fit: contain;
}

.tags-section {
	background: #fff;
	padding: 20px;
	margin: 0;
	transform: translateY(28px);
}

.tags-container {
	display: flex;
	flex-wrap: wrap;
	gap: 14px;
	max-width: 1280px;
	margin: 0 auto;
}

.tag-item {
	background: rgba(255, 245, 245, 1);
	color: rgba(236, 57, 57, 1);
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	padding: 8px 20px;
	border-radius: 4px;
	cursor: pointer;
	transition: all 0.3s;
}

.tag-item:hover {
	background: rgba(236, 57, 57, 1);
	color: #fff;
}

@media (max-width: 992px) {
	.main-content {
		flex-direction: column;
	}

	.sidebar {
		width: 100%;
	}

	.sidebar-item {
		display: inline-flex;
		margin-right: 10px;
		margin-bottom: 10px;
	}

	.related-list {
		grid-template-columns: repeat(2, 1fr);
	}
}

@media (max-width: 768px) {
	.related-list {
		grid-template-columns: 1fr;
	}
}

.qr-code-modal {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
}

.qr-code-content {
	background: #ffffff;
	border-radius: 12px;
	padding: 20px;
	width: 320px;
	text-align: center;
}

.qr-code-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 20px;
	padding-bottom: 15px;
	border-bottom: 1px solid #EEEEEE;
}

.qr-code-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 18px;
	color: #333333;
}

.qr-code-close {
	width: 32px;
	height: 32px;
	border: none;
	background: #F5F5F5;
	border-radius: 50%;
	font-size: 24px;
	color: #999999;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: 1;
}

.qr-code-close:hover {
	background: #EEEEEE;
}

.qr-code-body {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.qr-code-wrapper {
	background: #ffffff;
	padding: 15px;
	border: 1px solid #E4E4E4;
	border-radius: 8px;
	margin-bottom: 15px;
}

.qr-code-tip {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 16px;
	color: #333333;
	margin: 0 0 8px 0;
}

.qr-code-desc {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #999999;
	margin: 0;
}
</style>